import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import PageMeta from "../../components/common/PageMeta";
import { useEffect, useState } from "react";
import Spinner from "../../components/ui/Spinner";
import {
    DEFAULT_PAGE_DESCRIPTION,
    DEFAULT_PAGE_TITLE,
} from "../../utilities/constants";
import { useLocation } from 'react-router-dom';

const CategoryDetails = () => {
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const data = location.state.user;

    useEffect(() => {
        if (data) {
            setLoading(false);
        }
    }, [data]);


    return (
        <>
            <PageMeta
                title={`Category Details - ${DEFAULT_PAGE_TITLE}`}
                description={`Category Details - ${DEFAULT_PAGE_DESCRIPTION}`}
            />
            <div className="flex justify-between items-center mb-4">
                <PageBreadcrumb
                    pageTitle="Category Details"
                    breadcrumbs={[
                        { label: "Category", path: "/category" },
                        { label: "Category Details" }
                    ]}
                />
                <PageBreadcrumb pageTitle="Category Details" />
            </div>
            {loading ? (
                <div className="flex justify-center items-center">
                    <Spinner />
                </div>
            ) : (
                <div className="p-6 bg-white dark:bg-gray-800 rounded-lg mx-auto h-full">
                    <div className="flex flex-col md:flex-row gap-8">
                        <div className="flex flex-col items-center  md:items-start gap-6 w-full md:w-1/4">
                            <div className="w-40 h-40 overflow-hidden rounded-lg bg-gray-200 dark:bg-gray-700 flex items-center justify-center">
                                {console.log(' data?.photoUrl', data?.photoUrl)}
                                <img
                                    src={
                                        data?.imageUrl
                                            ? data?.imageUrl
                                            : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                                `${data?.displayName || ""} ${data?.displayName || ""}`
                                            )}&background=a8936a&color=fff`
                                    }
                                    alt="Profile"
                                    className="w-full h-full object-scale-down"
                                />
                            </div>
                            <div className="space-y-4 w-full">
                                <div>
                                    <h3 className="text-sm text-gray-500 dark:text-gray-400">Name</h3>
                                    <p className="text-base font-medium text-gray-900 dark:text-gray-100">
                                        {data?.displayName}
                                    </p>
                                </div>
                                <div>
                                    <h3 className="text-sm text-gray-500 dark:text-gray-400">Description</h3>
                                    <p className="text-base font-medium text-gray-900 dark:text-gray-100">
                                        {data?.description}
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Measurements */}
                        <div className="flex-1 md:pl-8 md:border-l border-gray-200 dark:border-gray-700">
                            <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-4">
                                Other Details
                            </h2>

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                <div className="p-4 rounded-lg bg-gray-50 dark:bg-gray-800 col-span-1 sm:col-span-2">
                                    <h3 className="text-sm text-gray-500 dark:text-gray-400 mb-2">Category Tags</h3>
                                    <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-200 text-sm">
                                        {data?.tags?.map((tag, index) => (
                                            <li key={index}>{tag}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            )}
        </>
    );
}
export default CategoryDetails;